import {
  addVirtualPosProps,
  addVirtualPosResponse,
} from "@/lib/types/DTO/core";
import { useMutation } from "@tanstack/react-query";
import { createData } from "@/lib/services/data-layer";
import { url } from "@/lib/services/data-layer/core";

const addVirtualPos = async (
  props: addVirtualPosProps
): Promise<addVirtualPosResponse> => {
  return await createData(url + `vpos`, props);
};

export const useAddVirtualPosMutation = () => {
  return useMutation({
    mutationFn: addVirtualPos,
  });
};
